export default __webpack_public_path__ + "static/media/icon-paper.8e220463.svg";